import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PIQ_THEME: DiToken<Record<string, any>> = new DiToken<Record<string, any>>('PIQ_THEME', {
  factory: () => ({})
});

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PIQ_CSS: DiToken<string> = new DiToken<string>('PIQ_CSS', {
  factory: () => ''
});

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PIQ_THEME_ALTERNATIVE: DiToken<Record<string, any>> = new DiToken<Record<string, any>>(
  'PIQ_THEME_ALTERNATIVE',
  {
    factory: () => ({})
  }
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PIQ_CSS_ALTERNATIVE: DiToken<string> = new DiToken<string>('PIQ_CSS_ALTERNATIVE', {
  factory: () => ''
});

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PIQ_THEME_GAME: DiToken<Record<string, any>> = new DiToken<Record<string, any>>('PIQ_THEME_GAME', {
  factory: () => ({})
});

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PIQ_CSS_GAME: DiToken<string> = new DiToken<string>('PIQ_CSS_GAME', {
  factory: () => ''
});
